import {
  selectCartEntries,
  selectIsPricingOrder,
  selectMinimalCartEntries,
  selectPricedOrderId,
} from './cart/cart.selectors';

export const orderingSelectors = {
  // Cart selectors
  selectCartEntries,
  selectMinimalCartEntries,
  selectIsPricingOrder,
  selectPricedOrderId,
};
